export function hasBossAccess(post: string): boolean {
    return post === 'BOSS' || post === 'ADMIN';
}
